<div class="pc-report-modal" (click)="$event.stopPropagation()">
  <header class="pc-report-modal__header">
    <div class="pc-report-modal__title-block">
      <div class="pc-report-modal__title-icon" aria-hidden="true">
        <mat-icon>download</mat-icon>
      </div>
      <div class="pc-report-modal__title-text">
        <h2 class="pc-report-modal__title">Download Port Consumption Report</h2>
        <p class="pc-report-modal__subtitle" *ngIf="data?.vesselName">
          {{ data.vesselName }}
        </p>
      </div>
    </div>

    <button
      type="button"
      class="pc-report-modal__close"
      (click)="close()"
      [disabled]="isProcessing"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="pc-report-modal__body">
    <p class="pc-report-modal__hint">
      Choose which report you want to download.
    </p>

    <div class="pc-report-modal__actions">
      <button
        type="button"
        class="pc-report-modal__action"
        [class.pc-report-modal__action--unavailable]="!hasNewReport"
        [disabled]="!hasNewReport || isProcessing"
        (click)="downloadNewReport()"
      >
        <mat-icon>description</mat-icon>
        <span class="pc-report-modal__action-label">
          {{ hasNewReport ? 'Download New Report' : 'New Report Not Available' }}
        </span>
        <mat-icon class="pc-report-modal__action-arrow">arrow_forward</mat-icon>
      </button>
    </div>
  </div>

  <footer class="pc-report-modal__footer">
    <button
      type="button"
      class="pc-report-modal__cancel"
      [disabled]="isProcessing"
      (click)="close()"
    >
      Cancel
    </button>
  </footer>

  <div class="pc-report-modal__processing" *ngIf="isProcessing" role="status" aria-live="polite">
    <div class="pc-report-modal__processing-card">
      <mat-spinner diameter="40"></mat-spinner>
      <p class="pc-report-modal__processing-title">{{ processingMessage }}</p>
      <p class="pc-report-modal__processing-subtitle">Processing your request...</p>
    </div>
  </div>
</div>
